import React from 'react';
import Icons from 'components/atoms/Icons';

type ChipProps = {
  leadingIcon?: string;
  label: string;
  count?: number;
  filterName: string;
  filterCategory: string;
  removeFilter: Function;
};

const Chip = (props: ChipProps) => {
  const label = props.label ? props.label : props.filterName;
  const count = props.count && props.count > 0 && props.count;
  return (
    <button
      className="chip"
      onClick={() => {
        props.removeFilter(props.filterCategory, props.filterName);
      }}
      aria-label={'Remove ' + props.label + ' filter.'}
    >
      {props.leadingIcon && (
        <Icons
          id={props.leadingIcon}
          className={`icon ${props.leadingIcon}`}
          aria-role="img"
          aria-hidden="true"
        />
      )}
      <p
        className="chip-label"
        onClick={() => {
          props.removeFilter(props.filterCategory, props.filterName);
        }}
      >
        {label}
        {count ? ` (${count})` : ''}
      </p>
      <Icons
        id="close"
        className="icon icon-close"
        aria-role="img"
        aria-hidden="true"
      />
    </button>
  );
};

export default Chip;
